import React, { useRef, useState, useEffect } from "react";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import "./deck.css";
import base from '../../res/base.jpg';
import ImportDeck from "../Importdeck";
import Cardmini from "../Cardmini";
import ExportImageButton from '../ExportImageButton';
import '../Options/options.css';

const Deck = ({ menuOpen }) => {
    const dispatch = useDispatch();
    const { 
        main: main_deck, 
        groupedByType, 
        goldCurve 
    } = useSelector(state => state.deck);
    
    const canvasRef = useRef(null);
    const [isExporting, setIsExporting] = useState(false);

    const totalCards = main_deck.reduce((sum, card) => sum + card.quantity, 0);
    const handleAddCard = (card) => {
        // Actualiza el estado local primero
        const updatedDeck = [...main_deck, card];
        
        // Luego actualiza Redux
        dispatch({ 
            type: 'UPDATE_DECK', 
            payload: updatedDeck 
        });
        
        // Finalmente actualiza los grupos
        dispatch({ type: 'UPDATE_DECK_GROUPS' });
    };
    const groupByType = (deck) => {
        return deck.reduce((groups, card) => {
            const type = card.Tipo || "Desconocido";
            if (!groups[type]) groups[type] = [];
            groups[type].push(card);
            return groups;
        }, {});
    };

    const groupByGold = (deck) => {
        return deck.reduce((groups, card) => {
            const cost = card.Coste;
            if (cost === undefined || cost === null || isNaN(cost)) return groups;
    
            if (!groups[cost]) groups[cost] = 0;
            groups[cost] += card.quantity;
            return groups;
        }, {});
    };

    const groupedMainDeck = groupByType(main_deck);


// Opción 1: Usar una acción compuesta (Recomendado)
const updateDeckAndGroups = async (action, payload) => {
    // Primero dispatch la acción principal
    await dispatch({ type: action, payload });
    
    // Luego dispatch la actualización de grupos
    dispatch({ type: "UPDATE_DECK_GROUPS" });
    
    // Debug
    console.log(`Dispatched ${action} and UPDATE_DECK_GROUPS`);
  };
  const handleQuantityChange = (card, change) => {
    if (card.quantity + change <= 0) {
      updateDeckAndGroups("REMOVE_CARD", { Id: card.Id });
    } else {
      updateDeckAndGroups(
        change > 0 ? "ADD_CARD_TO_DECK" : "REMOVE_CARD",
        { Id: card.Id }
      );
    }
  };
  
  const [, drop] = useDrop({
    accept: "Card",
    drop: (item) => updateDeckAndGroups("ADD_CARD_TO_DECK", item.card),
  });

    return (
        <div className="deck-container" ref={drop}>
            <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

            <div className="deck">
                <div className="ImportDeck">
                    <ImportDeck />
                </div>
                <div className="deck-total">Total {totalCards} cartas</div>
                {Object.entries(groupedMainDeck).map(([type, cards]) => (
                    <div key={type} className="card-group">
                        <h4>{type} ({cards.reduce((sum, c) => sum + c.quantity, 0)})</h4>
                        <div className="card-list">
                            {cards.map((card) => (
                                <div key={card.Id || card.Nombre} className="card-container">
                                    <Cardmini
                                        key={card.Id || card.Nombre}
                                        cardInfo={card}
                                        onQuantityChange={handleQuantityChange}
                                    />
                                    <span className="card-quantity">{card.quantity}</span>
                                    <div className="quantity-controls">
                                        <button onClick={() => handleQuantityChange(card, -1)} className="btn-decrease">-</button>
                                        <button onClick={() => handleQuantityChange(card, 1)} className="btn-increase">+</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default Deck;
